import ComercialCard from './ComercialCard.js';

export default ComercialCard;
